import { render } from "./branch-list.vue?vue&type=template&id=be6e1a72"
import script from "./branch-list.vue?vue&type=script&lang=js"
export * from "./branch-list.vue?vue&type=script&lang=js"

import "./branch-list.vue?vue&type=style&index=0&id=be6e1a72&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__